import React  from "react";
import { Navigate } from "react-router-dom";
import { ROLES_PGI } from "../helpers/constants";

const ProtectedRoutePGI = ({ children }) => {
  
  const logueado = JSON.parse(localStorage.getItem('Usuario'))
  
  if (!logueado) {
    return <Navigate to="/pgi/login" />;
  } 
  
  if(logueado){
    const roleUser = logueado.UserLogin.role;
    const hasRequiredRole = ROLES_PGI.includes(roleUser);
    if (!hasRequiredRole) {
      return <Navigate to="/" />;
    }
  }

  return children; 
};

export default ProtectedRoutePGI;
